import React, { useState } from 'react'
import styles from './EmailTagInput.module.css'

const EmailTagInput = ({ emails = [], onChange, placeholder = 'e.g. hello@tiiny.host', id }) => {
  const [inputValue, setInputValue] = useState('')

  const hasEmail = (candidate) => emails.some((e) => String(e).toLowerCase() === candidate)

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault()
      const email = inputValue.trim().toLowerCase()
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (email && emailRegex.test(email) && !hasEmail(email)) {
        onChange([...emails, email])
        setInputValue('')
      }
    } else if (e.key === 'Backspace' && !inputValue && emails.length > 0) {
      onChange(emails.slice(0, -1))
    }
  }

  const removeEmail = (index) => {
    onChange(emails.filter((_, i) => i !== index))
  }

  const handleBlur = () => {
    const email = inputValue.trim().toLowerCase()
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (email && emailRegex.test(email) && !hasEmail(email)) {
      onChange([...emails, email])
      setInputValue('')
    }
  }

  return (
    <div className={styles.emailTagInputContainer}>
      <div className={styles.emailTags}>
        {emails.map((email, index) => (
          <div key={index} className={styles.emailTag}>
            <span>{email}</span>
            <button type="button" onClick={() => removeEmail(index)} className={styles.removeTag}>
              <img src="/assets/icons/cross.png" alt="remove" width="8" height="8" />
            </button>
          </div>
        ))}
        <input
          id={id}
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          placeholder={emails.length === 0 ? placeholder : ''}
          className={styles.emailTagInput}
        />
      </div>
    </div>
  )
}

export { styles as emailTagInputStyles }
export default EmailTagInput
